import { createContext } from "react";

import type { LocaleDefinition } from "../../types/locale-definition";
import type { LocaleSelection, SelectionSource } from "../../schemas";

interface LocaleContextProps {
	currentLocale: LocaleSelection;
	locales: LocaleDefinition[];
	setLocale: (locale: unknown, source: Exclude<SelectionSource, "system">) => void;
}

export const initialLocaleContextProps: LocaleContextProps = {
	currentLocale: { locale: "en", source: "system" },
	locales: [],
	setLocale: () => undefined,
};

export const LocaleContext = createContext<LocaleContextProps>(initialLocaleContextProps);
